<script setup>
import { useAuthorStore } from "@/stores/useAuthorStore";
import DeleteConfirmModal from "@/components/Generics/DeleteConfirmModal.vue";

const emit = defineEmits(["close", "refresh", "notify"]);

const authorStore = useAuthorStore();

// ===============================
// Tratamento de erro específico
// ===============================
function buildAuthorDeleteError(error) {
  const FOREIGN_KEY_ERROR_STRING =
    "Erro interno ao remover o autor: Cannot delete or update a parent row: a foreign key constraint fails (`litterae`.`texts`, CONSTRAINT `fk_texts_authors1` FOREIGN KEY (`author_id`) REFERENCES `authors` (`author_id`))";

  const raw = error?.response?.data?.message || error?.message || "";

  let userFriendlyMessage =
    "Não é possível excluir esse AUTOR porque existe TEXTO cadastrado vinculado a ele.";

  if (raw.trim() === FOREIGN_KEY_ERROR_STRING.trim()) {
    userFriendlyMessage =
      "Este autor está vinculado a um ou mais Textos e não pode ser removido.\nPara excluí-lo, remova todos os textos associados a este autor primeiro.";
  } else if (raw) {
    userFriendlyMessage = raw;
  }

  return userFriendlyMessage;
}

async function onConfirmDelete() {
  try {
    await authorStore.deleteAuthorById(authorStore.idAuthor);

    authorStore.shouldForcePageOne = true;

    emit("notify", {
      type: "success",
      message: "Autor apagado com sucesso.",
    });

    emit("refresh");
    emit("close");
  } catch (error) {
    const msg = buildAuthorDeleteError(error);

    emit("notify", {
      type: "error",
      message: msg,
    });

    throw new Error(msg);
  }
}
</script>

<template>
  <DeleteConfirmModal
    :show="true"
    title="Apagar Autor"
    messageTitle="Tem certeza que deseja excluir este autor?"
    messageSubtitle="Esta ação não pode ser desfeita."
    confirmText="Sim, excluir"
    cancelText="Cancelar"
    loadingText="Apagando..."
    :onConfirm="onConfirmDelete"
    @close="emit('close')"
  />
</template>
